
import React, { useCallback, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Button, Container, InputGroup } from '@themesberg/react-bootstrap';

import { login } from '../../controller/api/auth'
import { useCookies } from 'react-cookie';

export default () => {

  const [, setCookie] = useCookies(['wvivu']);

  const _env = useRef('PROD');

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const onEmailInput = ({ target: { value } }) => setEmail(value)

  const onPasswordInput = ({ target: { value } }) => setPassword(value)

  const handleSubmit = async (event) => {
    event.preventDefault()

    const token = await login(
      _env.current,
      email,
      password
    )

    localStorage.setItem('email', token.email)

    localStorage.setItem('permission', token.permission)

    setCookie('wvivu', token.token, { path: '/' });

  }

  const _handleChangeEnv = useCallback((payload) => {
    _env.current = payload.target.value
  }, [])

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row className="justify-content-center form-bg-image">
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Đăng nhập</h3>
                </div>
                <Form className="mt-4" onSubmit={handleSubmit}>
                  <Form.Group id="environment" className="mb-4">
                    <Form.Label>Môi trường</Form.Label>
                    <Form.Select onChange={_handleChangeEnv}>
                      <option value={'PROD'}>LIVE</option>
                      <option value={'DEV'}>TEST</option>
                      <option value={'LOCAL'}>LOCAL</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Email</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                      <Form.Control autoFocus required type="email" placeholder="example@company.com" name="email" value={email} onChange={onEmailInput} />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>Mật khẩu</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control required type="password" placeholder="Password" name="password" value={password} onChange={onPasswordInput} />
                      </InputGroup>
                    </Form.Group>
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100">
                    Đăng nhập
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
